import { render, staticRenderFns } from "./studyList.vue?vue&type=template&id=0dee2746&scoped=true&"
import script from "./studyList.vue?vue&type=script&lang=js&"
export * from "./studyList.vue?vue&type=script&lang=js&"
import style0 from "./studyList.vue?vue&type=style&index=0&id=0dee2746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee2746",
  null
  
)

export default component.exports